import React, { PureComponent } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

export default class FileSectionContent extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    half: PropTypes.bool
  };

  render() {
    const { className, children, half } = this.props;
    const classComponent = classNames(
      'file__content',
      { 'file__content--half': half },
      className
    );

    return <div className={classComponent}>{children}</div>;
  }
}
